


































import { Either } from 'fp-ts/lib/Either'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { AutoLoadComplete, AutoLoadError } from '@/components/organisms/auto-load/model'
import ItemListAutoLoadable from '@/components/organisms/item-list/AutoLoadable.vue'
import ApiBrand from '@/models/api/brand'
import { ListWithPagination } from '@/models/api/response/list'
import { ItemKind } from '@/models/item/kind'
import FavoriteItemService from '@/services/api/favorite-item'
import ItemService from '@/services/api/productclass'
import AppId from '@/util/appid'

import { log } from '@/log'
import BehaviorConfig from '@/models/app-config/behavior/behavior'

@Component({
  components: {
    ItemListAutoLoadable,
  },
})
export default class FavoriteItems extends Vue {

  @Prop({ default: null })
  brand: ApiBrand | null

  message: string = ''

  get brandEnglishName(): string {
    return this.brand ? this.brand.englishName : ''
  }

  get appId(): string {
    return AppId.getByBrandName(this.brandEnglishName)
  }

  get itemKind(): ItemKind {
    const behavior = BehaviorConfig.createFromBrand(this.brand)

    return behavior.itemList.layout as ItemKind
  }

  itemService = new ItemService()
  favoriteItemService = new FavoriteItemService()

  fetchItemList(baseQuery: object): Promise<Either<Error, ListWithPagination<any>>> {
    return this.favoriteItemService.listWithPagination({
      ...baseQuery,
      ...this.brand && { brand: this.brand.englishName },
    })
  }

  onError(error: AutoLoadError) {
    log.error(error)

    this.message = 'データを取得できませんでした'
  }

  onComplete(result: AutoLoadComplete) {
    if (!result.pagination || result.pagination.total === 0) {
      this.message = 'お気に入りに登録している商品はありません'

      return
    }
  }

  get shouldAutoload(): boolean {
    return !this.message
  }
}
